import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'
import objectPath from 'object-path'
import {connect} from 'react-redux'
import Spinner from '../../layout/CenterSpinner'

import {URL, URLSearchParams} from 'whatwg-url'

import {staffLogin, syncTokenWithLegacy, LOGIN_SYNC_TOKEN_WITH_LEGACY} from 'mb-app-common/store/actions/auth'
import Config from 'mb-app-common/lib/config'
import redirect from '../../../lib/redirect'
import {link as clientWebLink} from '../../../lib/clientweb'
import StaffForm from './Form'

import {isLoading} from 'mb-app-common/lib/util/loading'

export class OpenIDStaffLogin extends PureComponent{
	static propTypes = {
		dispatch: PropTypes.func,
		staffUsername: PropTypes.string,
		clientUsername: PropTypes.string,
		isLoggedIn: PropTypes.bool.isRequired,
		location: PropTypes.shape({
			pathname: PropTypes.string.isRequired,
			search: PropTypes.string.isRequired
		}).isRequired,
		history: PropTypes.shape({
			replace: PropTypes.func.isRequired
		}).isRequired,
		rawToken: PropTypes.string,
		isLoading: PropTypes.bool
	}

	constructor(props){
		super(props)

		this.callbackUrl = new URL('/login/staff', document.location.protocol + '//' + document.location.host)
	}

	doRedirect(client = false){
		const url = new URL('identity/connect/authorize', Config.IDENTITYSERVER_ENDPOINT)
		url.searchParams.set('client_id', 'ro.web')
		url.searchParams.set('scope', 'api offline_access openid')
		url.searchParams.set('response_type', 'code')
		url.searchParams.set('redirect_uri', this.callbackUrl)
		url.searchParams.set('acr_values', `idp:Federation${client ? ` client_username:${client}` : ''}`)

		redirect(url)
	}

	async componentWillMount(){
		const params = new URLSearchParams(this.props.location.search)

		if(params.get('code')){
			// Request token from identity server and then sync it with php
			const code = params.get('code')

			const timeout = (ms) => new Promise(resolve => setTimeout(resolve, ms))
			let login

			// Try to fetch the code multiple times, due to identityserver sso being flakey
			for(let i = 0; i < 5; i++){
				console.log("Token fetching")
				login = await this.props.dispatch(staffLogin(code, this.callbackUrl))
				if(login.token && login.token.accessToken){
					this.props.dispatch(syncTokenWithLegacy(login.token.accessToken))
					break
				}else{
					console.log(`Token fetching: trying again in ${i * 700} milliseconds`)
					login = false
					await timeout(i * 700)
				}
			}

			// Try to get another SSO token if this one is bad
			if(!login){
				this.doRedirect()
			}

			this.props.history.replace('/login/staff') // Remove the get params from the url
		}else if(!this.props.isLoggedIn){
			this.doRedirect()
		}
	}

	componentWillReceiveProps(nextProps){
		if(!this.props.clientUsername && nextProps.clientUsername){
			return this.doRedirectToClientSite()
		}
	}

	changeClient(client = false){
		if(client && this.props.clientUsername === client.replace(/-[12]/, '')){
			this.doRedirectToClientSite()
		}else{
			return this.doRedirect(client)
		}
	}

	doRedirectToClientSite(){
		return this.props.dispatch(syncTokenWithLegacy(this.props.rawToken)).then(() => {
			this.props.history.replace('/home')
		})
	}

	redirectToStaffSite(e){
		if(e){
			e.preventDefault()
		}

		return this.props.dispatch(syncTokenWithLegacy(this.props.rawToken)).then(() => {
			redirect(clientWebLink('/staff/messages'))
		})
	}

	render(){
		if(!this.props.isLoggedIn){
			return <Spinner size="100px"/>
		}else{
			return <StaffForm
				staffUsername={this.props.staffUsername}
				changeClientCallback={this.changeClient.bind(this)}
				redirectToStaff={this.redirectToStaffSite.bind(this)}
				isLoading={this.props.isLoading}
			/>
		}
	}
}

export default withRouter(connect((state) => ({
	isLoggedIn: objectPath.has(state.Auth.token, 'sub') && objectPath.get(state.Auth.token, 'idp', false) == 'Federation',
	staffUsername: objectPath.get(state.Auth.token, 'sub'),
	clientUsername: objectPath.get(state.Auth.token, 'accountNumber'),
	rawToken: objectPath.get(state.Auth, 'token.accessToken'),
	isLoading: isLoading(state.Loading, LOGIN_SYNC_TOKEN_WITH_LEGACY)
}))(OpenIDStaffLogin))



// WEBPACK FOOTER //
// ./client/components/Login/Staff/index.js